import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AdminAuthProvider } from "./context/AdminAuthContext";
import { CustomerAuthProvider } from "./context/CustomerAuthContext";
import { ToastProvider } from "./context/ToastContext";
import { ThemeProvider } from "./context/ThemeContext";
import AppErrorBoundary from "./components/common/AppErrorBoundary";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider>
        <ToastProvider>
          <CustomerAuthProvider>
            <AdminAuthProvider>
              <BrowserRouter basename={__BASE_PATH__}>
                <AppErrorBoundary>
                  <AppRoutes />
                </AppErrorBoundary>
              </BrowserRouter>
            </AdminAuthProvider>
          </CustomerAuthProvider>
        </ToastProvider>
      </ThemeProvider>
    </I18nextProvider>
  );
}

export default App;
